const keyMap = {
  appointment: 1,   // 预约
  triage: 2,        // 分诊
  intention: 2,     // 意向
  sexMan: '男',
  sexFemale: '女'
};

export default keyMap;
